import React, { Component } from 'react';
import Switch from "react-switch";
import Select from 'react-select';
import { Row, Col, Grid, Table, Popover, OverlayTrigger } from "react-bootstrap";
import { toast } from 'react-toastify';


import { consultaOfertaDir } from '../../funciones/InscripcionFunction';
import { Inscribir } from '../../funciones/EstudiantesFunction';

import InscripcionTableDir from '../Inscripcion/InscripcionTableDir';
import SelectTableDir from '../Inscripcion/SelectTableDir';

let statusUser = 0;
let unCr = 0;
let statusBtn = 0;
let statusInsc = 0;

class EstInscripcion extends Component {
    state = {
        cr: 0,
        statusUser: 0,
        dataInscripcion: this.props.data[0].dataInscripcion,
        materias: [],
        notificacionClass: this.props.data[0].notificacionClass,
        notificacionIcon: this.props.data[0].notificacionIcon,
        notificacionText: this.props.data[0].notificacionText,
        notificacionStyles: {
            fontSize:12, position:"absolute", top: 4
        },
        textMateria: "Cargando Materias",
        materiasSelect: [],
        seccionesSelect: [],
        boton1: { Icon:"fa fa-check", Title:"Confirmar", disabled: ""},
        seccionesSelectFull: [],
        seccionesSelectFull2: this.props.data[0].seccionesSelectFull2,

        semestres: this.props.data[0].semestres,
        
        valorSemestres: { value: '', label: ' - Selecciona un Semestre - ' },
        mensajeTabla: "Selecciona primero un semestre",
        espera: "Espera por favor",
        materiasInsc: []
    }

    constructor (props) {
        super (props)
        statusBtn = props.data[1]
        /* unCr= props.data[2] */
        statusInsc = props.data[3]
    }

    componentDidMount = () => {
        /* console.log(this.props.data[2]); */

        unCr = 0
        let materiasInscritas = this.props.data[0].seccionesSelectFull3
        for (let i in materiasInscritas){
            unCr += materiasInscritas[i].uc
        }

        this.setState({
            /* materiasInsc: this.props.data[0].seccionesSelectFull, */
            seccionesSelectFull: materiasInscritas
        })
    }

    valorSemestres = (valorSemestres) => {
        /* unCr = 0; */
        this.setState({
            valorSemestres,
            mensajeTabla: <div><i className="fa fa-spinner fa-spin"></i> Cargando oferta académica</div>,
            /* seccionesSelectFull:[] */
        }, () => {
            consultaOfertaDir (valorSemestres.value, this.props.data[4], (resp) => {
                if(resp[0].length === 0){
                    this.setState({
                        mensajeTabla: "No hay materias disponibles",
                        materias: []
                    })
                }else{
                    this.setState({
                        materias: resp[0],
                        mensajeTabla: ""
                    })
                }
            })
        });
    }

    addMateria = (materia, seccion, uc) => {
        unCr += parseInt(uc)
        let mat = this.state.materiasSelect;
        let sec = this.state.seccionesSelect;
        let secFull = this.state.seccionesSelectFull;
        mat.push(materia)
        sec.push(seccion)
        secFull.push({
            id: seccion
        })
        this.setState({
            materiasSelect: mat,
            seccionesSelect: sec,
            seccionesSelectFull: secFull
        })
    }

    delMateria = (materia, seccion, uc) => {
        unCr -= uc
        let mat = this.state.materiasSelect;
        let sec = this.state.seccionesSelect;
        let secFull = this.state.seccionesSelectFull;
        for (let i in mat) {
            if (mat[i] === materia) mat.splice(i, 1);
        }
        for (let i in sec) {
            if (sec[i] === seccion) sec.splice(i, 1);
        }
        for (let i in secFull) {
            if (secFull[i].id === seccion.id || secFull[i].id.id === seccion.id) secFull.splice(i, 1);
        }
        this.setState({
            materiasSelect: mat,
            seccionesSelect: sec,
            seccionesSelectFull: secFull
        })
    }
    
    botones = () => {
        let { seccionesSelect, seccionesSelectFull, valorSemestres, boton1 } = this.state;
        const campos = { seccionesSelect, seccionesSelectFull, valorSemestres }
        
        let botonOk = () => (
            <button className="btn btn-primary" style={{borderWidth: 1}} onClick={ (e) => {
                this.setState({
                    boton1:{ Icon: "fa fa-spinner fa-spin", Title: "Cargando" }
                }, () => {
                    Inscribir (this.state.materiasInsc, this.props.data[4], campos, unCr, (resp) => {
                        this.setState({boton1: { Icon:"fa fa-check", Title:"Confirmar", disabled: ""}})
                        toast[resp.Type](resp.Text,{autoClose: 4000}); 

                        if(resp.Type !== "error"){
                            this.props.cerrar()
                        }
                    })
                })
            }}><i className={boton1.Icon}></i> {boton1.Title}</button>
        )
        
        switch (statusBtn) {
            case 0:
                return botonOk();
            case 1:
                return botonOk();
            case 2:
                return botonOk();
            case 3:
                /* return null */
                return botonOk();
            case 4:
                let contenido4 = (
                    <Popover bsSize="large" title="Importante" id="Inscrito">
                        <div className="custom-alert-primary" style={{fontSize:11}} align="center">¿Por qué no puedo realizar este proceso?</div>
                        <div align="justify" className="custom-mt-10">
                            El estudiante seleccionado tiene abierta una solicitud de Cambio de Carrera.
                        </div>
                    </Popover>
                )

                return (
                    <OverlayTrigger trigger="focus" placement="right" overlay={contenido4}>
                        <button style={{borderWidth: 1}} className="btn btn-primary"><i className={boton1.Icon}></i> {boton1.Title}</button>
                    </OverlayTrigger>
                )
            case 5:
                let contenido5 = (
                    <Popover bsSize="large" title="Importante" id="Inscrito">
                        <div className="custom-alert-primary" style={{fontSize:11}} align="center">¿Por qué no puedo realizar este proceso?</div>
                        <div align="justify" className="custom-mt-10">
                            El estudiante seleccionado tiene una inscripción pendiente de aprobación.
                        </div>
                    </Popover>
                )

                return (
                    <OverlayTrigger trigger="focus" placement="right" overlay={contenido5}>
                        <button style={{borderWidth: 1}} className="btn btn-primary"><i className={boton1.Icon}></i> {boton1.Title}</button>
                    </OverlayTrigger>
                )
            case 6:
                let contenido6 = (
                    <Popover bsSize="large" title="No puedes realizar esta acción" id="Inscrito6">
                        <div className="custom-alert-danger" style={{fontSize: 11}} align="center">¿Por qué no puedo realizar este proceso?</div>
                        <div align="justify" className="custom-mt-10">
                            El estudiante seleccionado no posee estado de cuenta. Debes esperar por Administración
                        </div>
                    </Popover>
                )

                return (
                    <OverlayTrigger trigger="focus" placement="right" overlay={contenido6}>
                        <button style={{borderWidth: 1}} className="btn btn-primary"><i className={boton1.Icon}></i> {boton1.Title}</button>
                    </OverlayTrigger>
                )
            case 7:
                /* let contenido7 = (
                    <Popover bsSize="large" title="No puedes realizar esta acción" id="Inscrito7">
                        <div className="custom-alert-danger" style={{fontSize: 11}} align="center">¿Por qué no puedo realizar este proceso?</div>
                        <div align="justify" className="custom-mt-10">
                            Actualmente el estudiante seleccionado tiene una deuda pendiente.
                        </div>
                    </Popover>
                )

                return (
                    <OverlayTrigger trigger="focus" placement="right" overlay={contenido7}>
                        <button style={{borderWidth: 1}} className="btn btn-primary"><i className={boton1.Icon}></i> {boton1.Title}</button>
                    </OverlayTrigger>
                ) */
                return botonOk();
            case 8:
                let contenido8 = (
                    <Popover bsSize="large" title="No puedes realizar esta acción" id="Inscrito7">
                        <div className="custom-alert-danger" style={{fontSize: 11}} align="center">¿Por qué no puedo realizar este proceso?</div>
                        <div align="justify" className="custom-mt-10">
                            Actualmente el estudiante seleccionado tiene un pago pendiente por aprobación.
                        </div>
                    </Popover>
                )

                return (
                    <OverlayTrigger trigger="focus" placement="right" overlay={contenido8}>
                        <button style={{borderWidth: 1}} className="btn btn-primary"><i className={boton1.Icon}></i> {boton1.Title}</button>
                    </OverlayTrigger>
                )
            default:
                return (
                    <button className="btn btn-primary" style={{borderWidth: 1}}><i className="fa fa-times" title="Presiona F5 para refrescar esta página"></i> Error al Cargar</button>
                )
        }
        
    }

    inscripcion = () => {
        let { dataInscripcion, materias, materiasSelect, seccionesSelectFull, valorSemestres, semestres, mensajeTabla } = this.state;


        const styles = {
            padding: 5, fontSize: 12
        }

        let contenidoMaterias = () => {
            if(materias.length === 0)return (
                <tr>
                    <td colSpan={8} align= "center" style={{padding: 5, fontSize: 12}}>
                        {mensajeTabla}
                    </td>
                </tr>
            )

            let contenido = [];
            let sec = 0;
            for (let i in materias) {
                if (materias[i].tipo_mat === "TEORICA") {
                    contenido.push(
                        <InscripcionTableDir key={ materias[i].seccionId } opciones={materias[i]} materiasS={materiasSelect}
                            sec = {sec}
                            idEst = {this.props.data[4]} 
                            add = {(materia, seccion, uc) => {this.addMateria(materia, seccion, uc)}}
                            del = {(materia, seccion, uc) => {this.delMateria(materia, seccion, uc)}} />
                    )
                    sec+=2000
                }
            }

            return contenido;
            
        }

        let contenidoMatElectvas = () => {
            let contenido = [];
            let elect = 0
            let sec = 0;
            for (let i in materias) {
                if (materias[i].tipo_mat === "ELECTIVA"){ contenido.push(
                    <InscripcionTableDir key={ materias[i].seccionId } opciones={materias[i]} materiasS={materiasSelect}
                    sec = {sec}    
                    idEst = {this.props.data[4]} 
                        add = {(materia, seccion, uc) => {this.addMateria(materia, seccion, uc)}}
                        del = {(materia, seccion, uc) => {this.delMateria(materia, seccion, uc)}} />
                    )
                    sec+=2000
                }
                elect ++;
            }

            if (elect > 0) {

                return (
                    <React.Fragment>
                        <div className="text-danger custom-mt-10">Materias Electivas Disponibles:</div>
                        {/* <div className="custom-mt-10" style={{marginTop: -2, fontSize: 10}}>Seleccionadas ({electSelect}) | Cursadas ({electCurs}) | Aprobadas ({electAp})</div> */}
                        <div className="table-responsive">
                            <Table striped hover bordered>
                                <tbody>
                                    <tr className="custon-back-color">
                                        <td width="55%" style={styles}><strong>Materia</strong></td>
                                        <td width="15%" align="center" style={styles}><strong>Sección</strong></td>
                                        <td width="15px" align="center" style={styles}><strong>Cupos</strong></td>
                                        <td width="15px" align="center" style={styles}><strong>U.C.</strong></td>
                                        <td width="25%" align="center" style={styles}><strong>Acciones</strong></td>
                                        <td width="40px" align="center" style={styles}><strong>Info</strong></td>
                                        <td width="5%" align="center" style={styles}></td>
                                    </tr>
                                    {contenido}
                                </tbody>
                            </Table>
                        </div>
                    </React.Fragment>
                )
            }
        }

        let materiaSeleccionadas = () => {
            
            let { seccionesSelectFull } = this.state;
            if(seccionesSelectFull.length === 0)return (
                <tr>
                    <td colSpan={5} align= "center" style={{padding: 5, fontSize: 12}}>
                    Ninguna Seleccionada
                    </td>
                </tr>
            )

            return (
                seccionesSelectFull.map(option => (
                    <SelectTableDir key={ option.id + Math.floor(Math.random() * 1000) } id= { option } type="Est" idEst = {this.props.data[4]}/>
                ))
            )
        }

        let seleccionaMaterias = () => {
            return (
                <React.Fragment>
                    <div className="custom-alert-info" style={{padding:10}}>
                        <Row>
                            <Col md={7}>
                                <div style={{fontSize:12}}>Completa los campos para formalizar tu inscripción para la carrera</div>
                                <div><strong>{dataInscripcion}</strong></div>
                            </Col>
                            <Col md={5}>
                                <Select
                                    isSearchable ={true}
                                    value={valorSemestres}
                                    onChange={this.valorSemestres}
                                    options={semestres}
                                />
                            </Col>
                        </Row>
                    </div>
                    <div className="text-danger custom-mt-10">Materias Disponibles:</div>    
                    <div className="table-responsive">
                        <Table striped hover bordered>
                            <tbody>
                                <tr className="custon-back-color">
                                    <td width="55%" style={styles}><strong>Materia</strong></td>
                                    <td width="15%" align="center" style={styles}><strong>Sección</strong></td>
                                    <td width="15px" align="center" style={styles}><strong>Cupos</strong></td>
                                    <td width="15px" align="center" style={styles}><strong>U.C.</strong></td>
                                    <td width="25%" align="center" style={styles}><strong>Acciones</strong></td>
                                    <td width="40px" align="center" style={styles}><strong>Info</strong></td>
                                    <td width="5%" align="center" style={styles}></td>
                                </tr>
                                {contenidoMaterias()}
                            </tbody>
                        </Table>
                    </div>

                    {contenidoMatElectvas()}
                </React.Fragment>
            )
        }

        return (
            <div className="custom-mt-20">
                {seleccionaMaterias()}
                {/* <div className="text-danger custom-mt-10">Materias Seleccionadas ({seccionesSelectFull.length}):</div>
                <div className="table-responsive">
                    <Table striped hover bordered>
                        <tbody>
                            <tr className="custon-back-color">
                                <td width="45%" style={styles}><strong>Materia</strong></td>
                                <td width="15%" align="center" style={styles}><strong>Sección</strong></td>
                                <td width="15%" align="center" style={styles}><strong>Modalidad</strong></td>
                                <td width="15%" align="center" style={styles}><strong>Semestre</strong></td>
                                <td width="10%" align="center" style={styles}><strong>U.C.</strong></td>
                            </tr>
                            {materiaSeleccionadas()}
                            <tr className="custon-back-color">
                                <td align="right" colSpan={4} width="90%" style={styles} ><strong>Total U.C.</strong></td>
                                <td width="10%" align="center" style={styles}>{ unCr }</td>
                            </tr>
                        </tbody>
                    </Table>
                </div> */}
                <Row>
                    <Col md={12} align="right" className ="custom-mt-10">
                        {this.botones()}
                    </Col>
                </Row>
            </div>
        )
    }

    change = () => {

    }

    ayuda = () => (
        <React.Fragment>
            <Row>
                <Col md={12}>
                    <strong style={{color:"#1f2f6e"}}>Paso 1:</strong>
                </Col>
                <Col md={12} align="justify">
                    <div>Selecciona <strong>El Semestre</strong> donde se encuentra la(s) materia(s) a inscribir.</div>
                </Col>
                <Col md={12} className="custom-mt-10">
                    <strong style={{color:"#1f2f6e"}}>Paso 2:</strong>
                </Col>
                <Col md={12} align="justify">
                    <div>Verás las materias disponibles para inscribir.</div>
                    <div>Selecciona la(s) materia(s) de la sección haciendo click en el boton <Switch
                    height={12} onChange={this.change} width={24} checked={false} /> que cambiara su estado a <Switch
                    height={12} onChange={this.change} width={24} checked={true} /> indicandote que la has seleccionado
                    </div>
                    <div>
                        El botón <button style={{borderWidth: 1}} className="btn btn-relleno-primary btn-xs">
                        <i className="fa fa-question-circle-o"></i></button> te mostrará mas información de la sección
                    </div>
                </Col>
                <Col md={12} align="justify" className="custom-mt-10">
                    <strong style={{color:"#1f2f6e"}}>Paso 3:</strong>
                </Col>
                <Col md={12} align="justify">
                    Selecciona el tipo de modalidad para la materia. (Presencial o Prueba de Suficiencia)
                </Col>
                <Col md={12} align="justify" className="custom-mt-10">
                    <strong style={{color:"#1f2f6e"}}>Paso 4:</strong>
                </Col>
                <Col md={12} align="justify">
                    Una vez seleccionada la(s) materia(s) verifica que son las correctas y presiona el botón <button 
                    style={{borderWidth: 1}} className="btn btn-primary btn-xs">
                    <i className="fa fa-check"></i> Continuar</button> para culminar el proceso
                </Col>
                <Col md={12} align="justify" className="custom-mt-10">
                    <strong style={{color:"#1f2f6e"}}>Paso 5:</strong>
                </Col>
                <Col md={12} align="justify">
                    El estudiante debe ingresar con su cuenta de usuario e imprimir la planilla de inscripción.
                </Col>
            </Row>
        </React.Fragment>
    )

    contenidOk = () => {
        let { notificacionClass, notificacionText, notificacionIcon, notificacionStyles } = this.state;
        let help1 = (
            <Popover title={<div align="center"><i className="fa fa-question-circle-o"></i> <strong>Detalles de la Inscripción</strong></div>} id="ins" style={{overflowY:"auto", height:"70vh"}}>
                {this.ayuda()}
            </Popover>
        )

        return(
            <React.Fragment>
                <div className="content">
                    <Grid fluid>
                        <Row>
                            <Col md={10} style={{paddingBottom:10}}>
                                <div className={notificacionClass} style={{padding:10}}>
                                    <Row>
                                        <Col md={11}><div style={{fontSize:16}}>{notificacionText}</div></Col>
                                        <Col md={1}><i className={notificacionIcon} style={notificacionStyles}></i></Col>
                                    </Row>
                                </div>
                            </Col>
                            <Col md={2} align="right" style={{paddingBottom:10}}>
                                <OverlayTrigger trigger="focus" placement="bottom" overlay={help1}>
                                    <button className="btn btn-warning" title="Ver Ayuda" style={{borderWidth: 1, marginTop:5}}><i className="fa fa-question-circle-o"></i></button>
                                </OverlayTrigger>
                            </Col>

                            <Col md={12} style={{overflowY:"auto", height:"69vh"}}>{this.inscripcion()}</Col>
                        </Row>
                    </Grid>
                </div>
            </React.Fragment>
        )
    }

    render() { 
        return (this.contenidOk())
    }
}
 
export default EstInscripcion;


// WEBPACK FOOTER //
// ./src/views/Registros/EstInscripcion.jsx